import React, { createContext, useContext, useState, ReactNode } from 'react';
import { PermissionAlert } from '../components/PermissionAlert';

interface PermissionContextType {
  showPermissionAlert: (message: string) => void;
}

const PermissionContext = createContext<PermissionContextType | undefined>(undefined);

export const usePermission = () => {
  const context = useContext(PermissionContext);
  if (!context) {
    throw new Error('usePermission must be used within PermissionProvider');
  }
  return context;
};

interface PermissionProviderProps {
  children: ReactNode;
}

export const PermissionProvider: React.FC<PermissionProviderProps> = ({ children }) => {
  const [alert, setAlert] = useState<{ message: string } | null>(null);

  const showPermissionAlert = (message: string) => {
    setAlert({ message });
  };

  const closeAlert = () => {
    setAlert(null);
  };

  return (
    <PermissionContext.Provider value={{ showPermissionAlert }}>
      {children}
      {alert && (
        <PermissionAlert 
          message={alert.message} 
          onClose={closeAlert} 
        />
      )}
    </PermissionContext.Provider>
  );
};
